import axios from '../axios'

var AuthService = function () {
  var user = null
  var refreshToken = null
  var validTill = null

  var currentTimer = null
  var startRefreshTokenTimer = function () {
    clearTimeout(currentTimer)
    var validInSeconds = (validTill.getTime() - (new Date()).getTime()) / 1000
    currentTimer = setTimeout(function () {
      getAccessTokenByRefreshToken(refreshToken)
    }, Math.abs(validInSeconds / 2) * 1000)
  }

  var getAccessTokenByRefreshToken = function (_refreshToken) { // jshint ignore:line
    return new Promise(function (resolve, reject) {
      axios.post('auth/refreshtoken', {RefreshToken: _refreshToken})
        .then(response => {
          user = response.data.User
          refreshToken = response.data.RefreshToken
          validTill = new Date(response.data.ValidTill)

          axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.AccessToken
          localStorage.setItem('refreshTokenPoss', refreshToken)

          startRefreshTokenTimer()

          resolve()
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  return {
    getLoginUser: function () {
      return this.loginUser
    },
    getUser: function () {
      return user
    },
    loginWithRefreshToken: function (_refreshToken) {
      return new Promise(function (resolve, reject) {
        getAccessTokenByRefreshToken(_refreshToken).then(function () {
          resolve()
        }).catch(function () {
          reject(new Error('Access token failed'))
        })
      })
    },
    login: function (loginUser) {
      this.loginUser = loginUser
      return new Promise(function (resolve, reject) {
        axios.post('auth/login', loginUser)
          .then(response => {
            user = response.data.User
            refreshToken = response.data.RefreshToken
            validTill = new Date(response.data.ValidTill)

            axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.AccessToken
            localStorage.setItem('refreshTokenPoss', refreshToken)

            startRefreshTokenTimer()

            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    acceptDisclaimer: function (loginUser) {
      return new Promise(function (resolve, reject) {
        axios.post('auth/acceptdisclaimer', loginUser)
          .then(response => {
            user = response.data.User
            refreshToken = response.data.RefreshToken
            validTill = new Date(response.data.ValidTill)

            axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.AccessToken
            localStorage.setItem('refreshTokenPoss', refreshToken)

            startRefreshTokenTimer()

            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },

    isAuthenticated: function () {
      return user !== null
    },
    logout: function () {
      user = null
      delete axios.defaults.headers.common.Authorization
      localStorage.removeItem('refreshTokenPoss')
    }
  }
}

export default new AuthService()



// WEBPACK FOOTER //
// ./src/services/AuthService.js